const browserDetect = require("detect-browser");
const NotificationService = require("ceres/app/services/NotificationService");
const AutoFocusService = require("ceres/app/services/AutoFocusService");

import { debounce } from "ceres/app/helper/debounce";
import Vue from "vue";
import { getStyle } from "ceres/app/helper/dom";

// Frontend end scripts
// eslint-disable-next-line
const headerCollapses = [];

function HeaderCollapse(selector)
{
    headerCollapses.push(selector);
    $(document).ready(function()
    {
        $(selector).on("show.bs.collapse", () =>
        {
            headerCollapses.forEach(element =>
            {
                if (!$(element).is(selector))
                {
                    $(element).collapse("hide");
                }
            });
        });

    });
}



function CeresMain()
{
    const browser = browserDetect.detect();

    if (browser && browser.name)
    {
        $("html").addClass(browser.name);
    }
    else
    {
        $("html").addClass("unkown-os");
    }

    $(window).scroll(function()
    {
        if ($(".wrapper-main").hasClass("isSticky"))
        {
            if ($(this).scrollTop() > 1)
            {
                $(".wrapper-main").addClass("sticky");
            }
            else
            {
                $(".wrapper-main").removeClass("sticky");
            }
        }
    });

    window.onpopstate = function(event)
    {
        if (event.state && event.state.requireReload)
        {
            window.location.reload();
        }
    };

    // init bootstrap tooltips
    $("[data-toggle=\"tooltip\"]").tooltip();

    HeaderCollapse("#countrySettings");
    HeaderCollapse("#currencySelect");
    HeaderCollapse("#searchBox");

    const $mainNavbarCollapse = $("#mainNavbarCollapse");

    // prevent hidding collapses in the shopbuilder, for editing search bar results
    if (!App.isShopBuilder)
    {
        $(document).on("click", function(evt)
        {
            headerCollapses.forEach(element =>
            {
                if (evt.target !== element && $(evt.target).parents(element).length <= 0)
                {
                    $(element).collapse("hide");
                }
            });
        });
    }

    $mainNavbarCollapse.collapse("hide");

    // Add click listener outside the navigation to close it
    $mainNavbarCollapse.on("show.bs.collapse", function()
    {
        $(".main").one("click", closeNav);
    });

    $mainNavbarCollapse.on("hide.bs.collapse", function()
    {
        $(".main").off("click", closeNav);
    });

    function closeNav()
    {
        $("#mainNavbarCollapse").collapse("hide");
    }

    $(document).ready(function()
    {
        const offset = 250;
        const duration = 300;

        let isDesktop = window.matchMedia("(min-width: 768px)").matches;

        AutoFocusService.autoFocus();

        $("#searchBox").on("shown.bs.collapse", function()
        {
            const searchInput = document.querySelector("input.search-input");

            if (searchInput)
            {
                searchInput.focus();
            }
        });

        $(window).scroll(function()
        {
            if (isDesktop)
            {
                if ($(this).scrollTop() > offset)
                {
                    $(".back-to-top").fadeIn(duration);
                    $(".back-to-top-center").fadeIn(duration);
                }
                else
                {
                    $(".back-to-top").fadeOut(duration);
                    $(".back-to-top-center").fadeOut(duration);
                }
            }
        });

        window.addEventListener("resize", function()
        {
            isDesktop = window.matchMedia("(min-width: 768px)").matches;
        });

        $(".back-to-top").click(function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $(".back-to-top-center").click(function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $("#accountMenuList").click(function()
        {
            $("#countrySettings").collapse("hide");
            $("#searchBox").collapse("hide");
            $("#currencySelect").collapse("hide");
        });

        fixPopperZIndexes();

        $('.dia-header-bot-mobile__item--teile, .dia-header-bot-mobile__item--search').click(function(){
            $('.mobile-navigation').removeClass("open");
            $('body').removeClass("menu-is-visible");
            document.querySelector(".icon-open").classList.add("active");
            document.querySelector(".icon-close").classList.remove("active");
        });

        $('.dia-header-bot-mobile__item--m-menu, .dia-header-bot-mobile__item--search').click(function(){
            if($('.steps-navigation').length){ // teile open
                // .dia-header-bot-mobile__item--teile
                $(".primary-navigation__item--mobile")[0].dispatchEvent(new Event("click"));
            }
        });

        $('.dia-footer__headline').click(function(){
            if(window.innerWidth < 768){
                //$(this).next("div:not(.dia-list)").toggleClass("is-closed");
                //$(this).nextAll(".dia-list").toggleClass("is-closed");
                //$(this).next("div").find(".dia-list").toggleClass("is-closed");
                $(this).toggleClass("is-closed");
                $(this).next(".footer-sub-content").toggleClass("is-closed");
            }
        });

        //$('.dia-footer__headline').click();
    });
}

jQuery(window).on("load", function(){
    if(window.innerWidth < 768){
        $('.dia-footer__headline').each(function(index, item){
            let height = $(item).nextAll().height();
            if(index == 3){
                height = height + 81;
            }
            if(index == 5){
                height = height + 35;
            }
            let html = "";
            let clone = "";
            if($(item).nextAll().length > 1){
                clone = [];
                $(item).nextAll().each(function(index2, item2){
                    html += $(item2)[0].outerHTML;
                    clone[index2] = $(item2).clone();
                });
            }else{
                html = $(item).nextAll()[0].outerHTML;
                clone = $(item).nextAll().clone();
            }
            //let html = $(item).nextAll()[0].outerHTML;
            $(item).nextAll().remove();
            //$(item).after("<div class='footer-sub-content is-open' style='height: "+height+"px'>"+html+"</div>");
            $(item).after("<div class='footer-sub-content is-closed' style='height: "+height+"px'></div>");
            if(Array.isArray(clone)){
                for(let key in clone){
                    $(item).next(".footer-sub-content").append(clone[key]);
                }
            }else{
                $(item).next(".footer-sub-content").append(clone);
            }
        });
        //$('.dia-footer__headline').click();
        $('.footer-sub-content').addClass("is-closed");
    }
});

window.CeresMain = new CeresMain();
window.CeresNotification = NotificationService;

const showShopNotification = function(event)
{
    if (event.detail.type)
    {
        switch (event.detail.type)
        {
        case "info":
            NotificationService.info(event.detail.message);
            break;
        case "log":
            NotificationService.log(event.detail.message);
            break;
        case "error":
            NotificationService.error(event.detail.message);
            break;
        case "success":
            NotificationService.success(event.detail.message);
            break;
        case "warning":
            NotificationService.warn(event.detail.message);
            break;
        default:
            console.log("no type such as:" + event.detail.type);
            break;
        }
    }
};

document.addEventListener("showShopNotification", showShopNotification);

let headerParent = document.querySelector("[data-header-offset]");

let headerLoaded = false;

let allHeaderChildrenHeights = [];

if ( headerParent )
{
    function calculateBodyOffset()
    {
        headerParent = headerParent.offsetParent ? headerParent : document.querySelector("[data-header-offset]");

        if (headerLoaded && headerParent)
        {
            const vueApp = document.getElementById("vue-app");

            let bodyOffset = 0;

            for ( let i = 0; i < headerParent.children.length; i++ )
            {
                bodyOffset += headerParent.children[i].getBoundingClientRect().height;
            }
            vueApp.style.marginTop = bodyOffset + "px";
            vueApp.style.minHeight = "calc(100vh - " + bodyOffset + "px)";
        }
    }

    function getHeaderChildrenHeights()
    {
        headerParent = headerParent.offsetParent ? headerParent : document.querySelector("[data-header-offset]");

        allHeaderChildrenHeights = [];

        for (let i = 0; i < headerParent.children.length; i++)
        {
            allHeaderChildrenHeights.push(headerParent.children[i].getBoundingClientRect().height);
        }
    }

    // function scrollHeaderElements()
    // {
    //     headerParent = headerParent.offsetParent ? headerParent : document.querySelector("[data-header-offset]");
    //
    //     if (headerLoaded && !App.isShopBuilder)
    //     {
    //         let absolutePos = 0;
    //
    //         let fixedElementsHeight = 0;
    //
    //         let offset = 0;
    //         const scrollTop = window.pageYOffset;
    //
    //         let zIndex = 100;
    //
    //         for (let i = 0; i < headerParent.children.length; i++)
    //         {
    //             const elem = headerParent.children[i];
    //             const elemHeight = allHeaderChildrenHeights[i];
    //
    //             offset = absolutePos - scrollTop;
    //             elem.style.position = "absolute";
    //             elem.style.zIndex = zIndex;
    //             zIndex--;
    //
    //             if (!elem.classList.contains("unfixed"))
    //             {
    //                 if (offset < 0)
    //                 {
    //                     elem.style.top = 0;
    //                 }
    //                 else
    //                 {
    //                     elem.style.top = offset + "px";
    //                 }
    //
    //                 if (fixedElementsHeight > 0 && offset < fixedElementsHeight)
    //                 {
    //                     elem.style.top = fixedElementsHeight + "px";
    //                 }
    //
    //                 fixedElementsHeight = fixedElementsHeight + elemHeight;
    //             }
    //             else
    //             {
    //                 elem.style.top = offset + "px";
    //             }
    //             absolutePos = absolutePos + elemHeight;
    //         }
    //     }
    // }

    window.addEventListener("resize", debounce(function()
    {
        calculateBodyOffset();
        getHeaderChildrenHeights();
        //scrollHeaderElements();
    }, 50));

    window.addEventListener("load", function()
    {
        calculateBodyOffset();
        getHeaderChildrenHeights();
        //scrollHeaderElements();
    });

    if (document.fonts)
    {
        document.fonts.onloadingdone = function(evt)
        {
            calculateBodyOffset();
            getHeaderChildrenHeights();
            //scrollHeaderElements();
        };
    }

    // window.addEventListener("scroll", debounce(function()
    // {
    //     scrollHeaderElements();
    // }, 10));

    $(document).on("shopbuilder.before.viewUpdate shopbuilder.after.viewUpdate", function()
    {
        calculateBodyOffset();
    });

    const headerImages = headerParent.querySelectorAll("img");

    Promise.all(
        Array.prototype.slice.call(headerImages).map(function(headerImage)
        {
            return new Promise(function(resolve)
            {
                if (headerImage.complete)
                {
                    resolve();
                }
                else
                {
                    headerImage.onload = function()
                    {
                        resolve();
                    };
                    headerImage.onerror = function()
                    {
                        resolve();
                    };
                }
            });
        })
    ).then(function()
    {
        // Initialize
        headerLoaded = true;
        getHeaderChildrenHeights();
        //scrollHeaderElements();
        calculateBodyOffset();
    });

    calculateBodyOffset();
}

$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
    let parent = widgetElement[1];

    let parentComponent = null;

    while (parent)
    {
        if (parent.__vue__)
        {
            parentComponent = parent.__vue__;
            break;
        }
        parent = parent.parentElement;
    }

    const compiled = Vue.compile(widgetElement[0].outerHTML, { delimiters: ["${", "}"] } );
    const component = new Vue({
        store: window.ceresStore,
        render: compiled.render,
        staticRenderFns: compiled.staticRenderFns,
        parent: parentComponent
    });

    component.$mount( widgetElement[0] );
    $(component.$el).find("*").each(function(index, elem)
    {
        $(elem).click(function(event)
        {
            event.preventDefault();
        });
    });

    $(component.$el).find(".owl-carousel").on("resized.owl.carousel", function()
    {
        window.dispatchEvent(new Event("resize"));
    });
});

function fixPopperZIndexes()
{
    const elements = document.querySelectorAll(".popover.d-none");

    let counter = elements.length;

    elements.forEach(el =>
    {
        let zIndex = parseInt(getStyle(el, "z-index"));

        if (!isNaN(zIndex))
        {
            zIndex += --counter;

            el.style.zIndex = zIndex;
        }
    });
}
